import React from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions from "../../utils/useWindowDimensions";

const GameEng = ({ gameList }) => {
  let { width } = useWindowDimensions();

  const sampleChartData = {
    series: [
      {
        name: "Activity",
        data: gameList.map((e) => e.count),
      },
    ],
    options: {
      chart: {
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: "straight",
        width: 2,
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.3,
          stops: [0, 100],
        },
      },
      grid: {
        row: {
          colors: ["transparent", "transparent"], // Set transparent colors
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: gameList.map((e) => e.game),
      },
      colors: ["#333333"],
    },
  };

  return (
    <>
      <div id="chart">
        <ReactApexChart
          options={sampleChartData.options}
          series={sampleChartData.series}
          type="area"
          height={width > 1400 && width < 1700 ? 235 : width >= 1700 ? 320 : 200}
        />
      </div>
    </>
  );
};

export default GameEng;
